import { FC, ReactNode } from 'react';
import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { OpmInputsYearDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import { filterHistoricEventDatesFromFirstEvent } from '../utils/OpmInputHelper';

interface HistoricCellsProps {
  indexIdentifier: string;
  className?: string;
  renderCell: (date: string, yearData: OpmInputsYearDto, index: number) => ReactNode;
}

const OpmInputHistoricCells: FC<HistoricCellsProps> = ({
  indexIdentifier,
  className = undefined,
  renderCell,
}) => {
  const opmInputResults = useAppSelector((state) => state.opmCalculation.calculatedInputs);
  const showHistoricDataColumns = useAppSelector(
    (state) => state.uiValues.userSelections.opmInputs.showHistoricDataColumns
  );
  const filteredHistoricDates = filterHistoricEventDatesFromFirstEvent(
    opmInputResults.historicEventDates
  );
  const historicDatesArray = Object.entries(filteredHistoricDates);

  if (!showHistoricDataColumns) {
    return null;
  }

  return (
    <>
      {historicDatesArray.map(([date, yearData], index) => (
        <td key={`historic-${indexIdentifier}-${date}`} className={className}>
          {renderCell(date, yearData, index)}
        </td>
      ))}
    </>
  );
};

export default OpmInputHistoricCells;
